import BasicResource from '@/api/resource';

class TasksResource extends BasicResource {

    constructor () {
        super('tasks');
    }

    upload ({ id, file }) {
        return this.client.request ({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/${id}/upload`,
            data: file,
        });
    }

    create ({ type, ...data }) {
        const payload = {
            name: data.name,
            context: { ...data },
        };

        return {
            'import_click_costs': () => this.createClicksImport(payload),
            'import_offers': () => this.createOffersImport(payload),
            'import_devices': () => this.createDevicesImport(payload),
            'import_proxies': () => this.createProxiesImport(payload),
            'event_status_change': () => this.createCsvEventStatusChange(payload),
            'parameters_generator': () => this.createParametersGeneratorImport(payload),
            'tsp_query_filtering': () => this.createTspQueryFilteringImport(payload),
        }[type]?.();
    }

    createClicksImport (data) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/tasks/csv-click-costs',
            data: data,
        });
    }

    createDevicesImport (data) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/tasks/csv-devices',
            data: data,
        });
    }

    createOffersImport (data) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/tasks/csv-offers',
            data: data,
        });
    }

    createCsvEventStatusChange (data) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/tasks/csv-event-status-change',
            data: data,
        });
    }

    createProxiesImport (data) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/tasks/csv-proxies',
            data: data,
        });
    }

    createParametersGeneratorImport (data) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/tasks/csv-parameters-generator',
            data: data,
        });
    }
    createTspQueryFilteringImport (data) {
        return this.client.request({
            method: 'post',
            path: '/upyield/v1/tasks/csv-tsp-query-filtering',
            data: data,
        });
    }

    step (taskId, { type, ...data }) {
        return {
            'import_click_costs': () => this.stepClicksImport(taskId, data),
            'import_offers': () => this.stepOffersImport(taskId, data),
            'import_devices': () => this.stepDevicesImport(taskId, data),
            'import_proxies': () => this.stepProxiesImport(taskId, data),
            'event_status_change': () => this.stepCsvEventStatusChange(taskId, data),
            'parameters_generator': () => this.stepParametersGeneratorImport(taskId, data),
            'tsp_query_filtering': () => this.stepTspQueryFilteringImport(taskId, data),
        }[type]?.();
    }

    stepClicksImport (taskId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/tasks/${taskId}/csv-click-costs/step`,
            data: data,
        });
    }

    stepDevicesImport (taskId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/tasks/${taskId}/csv-devices/step`,
            data: data,
        });
    }

    stepOffersImport (taskId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/tasks/${taskId}/csv-offers/step`,
            data: data,
        });
    }

    stepProxiesImport (taskId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/tasks/${taskId}/csv-proxies/step`,
            data: data,
        });
    }

    stepCsvEventStatusChange (taskId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/tasks/${taskId}/csv-event-status-change/step`,
            data: data,
        });
    }

    stepParametersGeneratorImport (taskId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/tasks/${taskId}/csv-parameters-generator/step`,
            data: data,
        });
    }
    stepTspQueryFilteringImport (taskId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/tasks/${taskId}/csv-tsp-query-filtering/step`,
            data: data,
        });
    }

    results (taskId, params, type) {
        return {
            'import_click_costs': () => this.clicksImportResults(taskId, params),
            'import_offers': () => this.offersImportResults(taskId, params),
            'import_devices': () => this.devicesImportResults(taskId, params),
            'import_proxies': () => this.proxiesImportResults(taskId, params),
            'event_status_change': () => this.csvEventStatusChangeImportResults(taskId, params),
            'parameters_generator': () => this.parametersGeneratorImportResults(taskId, params),
            'tsp_query_filtering': () => this.tspQueryFilteringImportResults(taskId, params),
        }[type]?.();
    }

    clicksImportResults (taskId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${taskId}/csv-click-costs/results`,
            params,
        });
    }

    devicesImportResults (taskId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${taskId}/csv-devices/results`,
            params,
        });
    }

    proxiesImportResults (taskId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${taskId}/csv-proxies/results`,
            params,
        });
    }

    offersImportResults (taskId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${taskId}/csv-offers/results`,
            params,
        });
    }

    csvEventStatusChangeImportResults (taskId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${taskId}/csv-event-status-change/results`,
            params,
        });
    }

    parametersGeneratorImportResults (taskId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${taskId}/csv-parameters-generator/results`,
            params,
        });
    }

    tspQueryFilteringImportResults (taskId, params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/${taskId}/csv-tsp-query-filtering/results`,
            params,
        });
    }

    deleteResultsRow (taskId, id) {
        return this.client.request ({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/${taskId}/results/${id}`,
        });
    }

    getTaskStatus ({ taskId, callbackOnProgress, isTaskReady, type, timeout = 2 * 1000, requestOptions = {} }) {
        const defaultPath = `/upyield/v1/tasks/${taskId}`;

        const path = {
            event_status_change: `/upyield/v1/tasks/${taskId}/csv-event-status-change`,
            event_adjust_mass: `/upyield/v1/tasks/${taskId}/mass-adjust`,
        }[type] || defaultPath;

        return this.client.poll({
            params: {
                method: 'get',
                path,
            },
            predicate: isTaskReady,
            timeout: timeout,
            retries: 450,
            callbackOnProgress,
            requestOptions,
        });
    }
}

export default new TasksResource;
